<section class="cbanner bannerbgcolor position-relative">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<!-- <img
					[hidden]="!allprojects && allprojects.length > 0"
					class="img-globe floatimg"
					src="{{ baseUrl }}/img/3D-images/home.webp"
					alt="Branding and web development agency"
					width="450"
					height="450"
					decoding="async"
				/> -->
				<div id="spline-container">
					<!-- <canvas id="canvas" class="floatimg"></canvas> -->
					<div #canvas style="width: 100%; height: 100%" class="floatimg"></div>
				</div>

				<div class="banner vh-100">
					<div
						class="d-flex flex-column justify-content-center h-100 align-items-start"
						style="backface-visibility: hidden"
					>
						<div class="contentbl">
							<h1 class="light size90 textcolor1">
								<!-- <h1 class="h1 fontsize90"> -->
								Brand Design and Web Development Agency in
								<span class="barcely"> Dubai </span>
							</h1>
						</div>
					</div>
				</div>
				<div
					class="position-absolute banner-left-content content-left"
					data-aos="fade-up"
				>
					<ul
						class="d-flex flex-column justify-contente-arround p-0 float-start"
						style="
							height: 130px;
							list-style: none;
							justify-content: space-between;
						"
					>
						<li>
							<a
								class=""
								href="https://www.instagram.com/pixtar.ae/"
								target="_blank"
								><img
									src="{{ baseUrl }}/img/home/social-media/instagram.svg"
									alt="Top creative agencies in dubai"
									width="15"
									height="15"
									loading="lazy"
									decoding="async"
							/></a>
						</li>
						<li>
							<a
								class=""
								href="https://www.facebook.com/pixtar.ae/"
								target="_blank"
								><img
									src="{{ baseUrl }}/img/home/social-media/facebook.svg"
									alt="best design agency"
									width="10"
									height="18"
									loading="lazy"
									decoding="async"
							/></a>
						</li>
						<li>
							<a
								class=""
								href="https://www.linkedin.com/company/pixtar-ae/"
								target="_blank"
								><img
									src="{{ baseUrl }}/img/home/social-media/linkedin.svg"
									alt="website development company dubai"
									width="15"
									height="15"
									loading="lazy"
									decoding="async"
							/></a>
						</li>
						<li>
							<a
								class="whatsapp-icon2 slideUpReturn tabmob"
								href="https://wa.me/+971527930781"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/whatsapp.svg"
									alt="Top branding agency in Dubai"
									width="18"
									height="18"
									loading="lazy"
									decoding="async"
								/>
							</a>
						</li>
					</ul>
					<div class="d-flex flex-column justify-contente-center left-content2">
						<p class="size24 textcolor1 lufgaregular">
							Building your business through
						</p>
						<p class="size24 textcolor1 lufgaregular">
							creativity, is our business!
						</p>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="position-absolute start-50 translate-middle down-arrow">
			<p>
				<a href="#" class="cta">
					<span>Click me</span>
					<svg width="13px" height="10px" viewBox="0 0 13 10">
						<path d="M1,5 L11,5"></path>
						<polyline points="8 1 12 5 8 9"></polyline>
					</svg>
				</a>
				<a href="projects" class="cstbtn">
					<span class="text"> See Our Work</span>
					<span class="borderspan"><i class="fa fa-chevron-right" aria-hidden="true"></i>
					</span>
				</a>
			</p>
		</div> -->

		<div class="position-absolute translate-middle down-arrow">
			<div class="linkToPackages">
				<a
					href="projects"
					class="d-flex justify-content-start align-items-center"
				>
					<span class="text textcolor1 semibold text-capitalize"
						>See Our Work
					</span>
					<i class="fa fa-chevron-right" aria-hidden="true"></i>
					<span class="borderspan"> </span>
				</a>
			</div>
		</div>
	</div>
</section>
<div class="bannerbgcolor cstheight"></div>
<section class="cstvideo" (window:scroll)="onScroll($event)">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-md-12 col-sm-11 col-11 mx-auto"
				[ngStyle]="{ width: sectionWidth + '%' }"
			>
				<div class="video-frame">
					<!-- <div class="overlay" onclick="this.nextElementSibling.style.display='block'; this.style.display='none'">
						<img src="{{ baseUrl }}/img/home/thumbnail-image.png" alt="Video thumbnail" class="w-100" />
						<div class="text-block text-center">
							<img class="" src="{{ baseUrl }}/img/home/play-icon.svg" alt="Achievement Image" />
						</div>
					</div> -->
					<!-- <iframe width="" height="680" id="aboutvideo"
						src="https://www.youtube.com/embed/2EVU53BXr_8?si=djmkfh_T2wJSfnWw" title="YouTube video player"
						frameborder="0"
						allow="accelerometer; autoplay=1; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						referrerpolicy="strict-origin-when-cross-origin" allowfullscreen style="width: 100%;"></iframe> -->
					<!-- <video class=" h-auto desktopimg" id="myVideo3" width="680" height="400" autoplay="true" loop="true"
						oncanplay="this.play()" onloadedmetadata="this.muted = true" (click)="openModal()">
						<source src="{{baseUrl}}/pixtar logo animation 6.MP4" type="video/mp4">
						<source src="{{baseUrl}}/pixtar logo animation 6.MP4" type="video/ogg">
						Your browser does not support HTML5 video.
					</video> -->
					<video
						#myVideo
						width="100%"
						muted
						autoplay
						(click)="playInFullscreenWithAudio()"
						style="cursor: pointer"
					>
						<source
							src="{{ baseUrl }}/videos/home-page-video.mp4"
							type="video/mp4"
						/>
						<source
							src="{{ baseUrl }}/videos/home-page-video.mp4"
							type="video/ogg"
						/>
						Your browser does not support the video tag.
					</video>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="toppadding" id="strategy">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-lg-7 col-md-6"
						data-aos="fade-up"
						data-aos-duration="1000"
						data-aos-delay="100"
						data-aos-once="true"
					>
						<div class="content custom-content d-flex flex-column h-100">
							<h2 class="fontsize12 semibold mb-4 text-uppercase textcolor1">
								What we offer
							</h2>
							<p class="heighlight lufgaregular">
								We don’t just design—we create harmony. With the precision of
								the golden ratio and the creativity of custom solutions,
								everything we craft is a one-of-a-kind masterpiece.
							</p>
							<!-- <div class="actn">
								<a href="/process" class="bthw">How ?</a>
							</div> -->
							<!-- <div class="position-relative actn">
								<div class="position-absolute start-50">
									<p>
										<a href="services" class="cstbtn cstbtn128">
											<span class="text text128 semibold">Explore Our Services</span>
											<span class="borderspan"><i class="fa fa-chevron-right" aria-hidden="true"></i>
											</span>
										</a>
									</p>
								</div>
							</div> -->

							<div class="linkToPackages">
								<a
									href="services"
									class="d-flex justify-content-start align-items-center"
								>
									<span class="text textcolor1 semibold text-capitalize">
										Explore Our Services
									</span>
									<i class="fa fa-chevron-right" aria-hidden="true"></i>
									<span class="borderspan ms-2"> </span>
								</a>
							</div>
						</div>
					</div>
					<div
						class="col-lg-5 col-md-6"
						data-aos="fade-up"
						data-aos-duration="1000"
						data-aos-delay="100"
						data-aos-once="true"
					>
						<div class="custom-collapse">
							<div class="accordion" id="accordionExample">
								<div class="accordion-item">
									<h2 class="accordion-header" id="headingBranding">
										<button
											class="accordion-button collapsed semibold text-capitalize"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseBranding"
											aria-expanded="false"
											aria-controls="collapseBranding"
										>
											Branding/Re-branding
										</button>
									</h2>
									<div
										id="collapseBranding"
										class="accordion-collapse collapse"
										aria-labelledby="headingBranding"
										data-bs-parent="#accordionExample"
									>
										<div class="accordion-body">
											Shape how the world sees you. We help you define your
											story and express it through iconic branding.
											<!-- <div class="position-relative actn wwo1">
												<div class="position-absolute start-50 wwo1-b1">
													<p>
														<a href="/branding" class="cstbtn">
															<span class="text semibold">Explore Branding Services</span>
															<span class="borderspan">
																<i class="fa fa-chevron-right" aria-hidden="true"></i>
															</span>
														</a>
													</p>
												</div>
											</div> -->

											<div class="linkToPackages">
												<a
													href="/services/branding"
													class="d-flex justify-content-start align-items-center"
												>
													<span
														class="text textcolor1 semibold text-capitalize"
													>
														Explore Branding Services
													</span>
													<i class="fa fa-chevron-right" aria-hidden="true"></i>
													<span class="borderspan ms-2"> </span>
												</a>
											</div>
										</div>
									</div>
								</div>

								<div class="accordion-item">
									<h2 class="accordion-header" id="headingWebsite">
										<button
											class="accordion-button collapsed semibold text-capitalize"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseWebsite"
											aria-expanded="false"
											aria-controls="collapseWebsite"
										>
											Custom Website
										</button>
									</h2>
									<div
										id="collapseWebsite"
										class="accordion-collapse collapse"
										aria-labelledby="headingWebsite"
										data-bs-parent="#accordionExample"
									>
										<div class="accordion-body">
											Pixel-perfect, fast, and beautiful websites designed to
											perform on every screen.
											<!-- <div class="position-relative actn wwo1">
												<div class="position-absolute start-50 wwo1-b3">
													<p>
														<a href="/website" class="cstbtn">
															<span class="text wwo1-b3-text semibold">Explore Website Service</span>
															<span class="borderspan">
																<i class="fa fa-chevron-right" aria-hidden="true"></i>
															</span>
														</a>
													</p>
												</div>
											</div> -->
											<div class="linkToPackages">
												<a
													href="/services/website-development"
													class="d-flex justify-content-start align-items-center"
												>
													<span
														class="text textcolor1 semibold text-capitalize"
													>
														Explore Website Services
													</span>
													<i class="fa fa-chevron-right" aria-hidden="true"></i>
													<span class="borderspan ms-2"> </span>
												</a>
											</div>
										</div>
									</div>
								</div>

								<div class="accordion-item">
									<h2 class="accordion-header" id="headingEcommerce">
										<button
											class="accordion-button collapsed semibold text-capitalize"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseEcommerce"
											aria-expanded="false"
											aria-controls="collapseEcommerce"
										>
											ecommerce Solutions
										</button>
									</h2>
									<div
										id="collapseEcommerce"
										class="accordion-collapse collapse"
										aria-labelledby="headingEcommerce"
										data-bs-parent="#accordionExample"
									>
										<div class="accordion-body">
											Launch a custom-built online store that engages, converts,
											and grows.
											<!-- <div class="position-relative actn wwo1">
												<div class="position-absolute start-50 wwo1-b4">
													<p>
														<a href="/ecommerce" class="cstbtn">
															<span class="text wwo1-b4-text semibold">Explore Packages</span>
															<span class="borderspan">
																<i class="fa fa-chevron-right" aria-hidden="true"></i>
															</span>
														</a>
													</p>
												</div>
											</div> -->

											<div class="linkToPackages">
												<a
													href="/services/ecommerce-web-development"
													class="d-flex justify-content-start align-items-center"
												>
													<span
														class="text textcolor1 semibold text-capitalize"
													>
														Explore ecommerce services
													</span>
													<i class="fa fa-chevron-right" aria-hidden="true"></i>
													<span class="borderspan ms-2"> </span>
												</a>
											</div>
										</div>
									</div>
								</div>

								<div class="accordion-item">
									<h2 class="accordion-header" id="headingWebApps">
										<button
											class="accordion-button collapsed semibold text-capitalize"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseWebApps"
											aria-expanded="false"
											aria-controls="collapseWebApps"
										>
											Web Applications
										</button>
									</h2>
									<div
										id="collapseWebApps"
										class="accordion-collapse collapse"
										aria-labelledby="headingWebApps"
										data-bs-parent="#accordionExample"
									>
										<div class="accordion-body">
											Custom web applications built to scale with your business.
											<!-- <div class="position-relative actn wwo1">
												<div class="position-absolute start-50 wwo1-b2">
													<p>
														<a href="/web-apps" class="cstbtn">
															<span class="text wwo1-b2-text semibold">Explore Plans</span>
															<span class="borderspan">
																<i class="fa fa-chevron-right" aria-hidden="true"></i>
															</span>
														</a>
													</p>
												</div>
											</div> -->

											<div class="linkToPackages">
												<a
													href="/services/ecommerce-web-development"
													class="d-flex justify-content-start align-items-center"
												>
													<span
														class="text textcolor1 semibold text-capitalize"
													>
														Explore web services
													</span>
													<i class="fa fa-chevron-right" aria-hidden="true"></i>
													<span class="borderspan ms-2"> </span>
												</a>
											</div>
										</div>
									</div>
								</div>

								<div class="accordion-item">
									<h2 class="accordion-header" id="headingGraphicDesign">
										<button
											class="accordion-button collapsed semibold text-capitalize"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseGraphicDesign"
											aria-expanded="false"
											aria-controls="collapseGraphicDesign"
										>
											Graphic Design
										</button>
									</h2>
									<div
										id="collapseGraphicDesign"
										class="accordion-collapse collapse"
										aria-labelledby="headingGraphicDesign"
										data-bs-parent="#accordionExample"
									>
										<div class="accordion-body">
											Stunning visuals tailored to your brand identity and
											marketing needs.
											<!-- <div class="position-relative actn wwo1">
												<div class="position-absolute start-50 wwo1-b5">
													<div class="position-absolute start-50 wwo1-b5">
														<p>
															<a href="/graphics" class="cstbtn">
																<span class="text wwo1-b5-text semibold">Explore Plans</span>
																<span class="borderspan">
																	<i class="fa fa-chevron-right" aria-hidden="true"></i>
																</span>
															</a>
														</p>
													</div>
												</div>
											</div> -->
											<div class="linkToPackages">
												<a
													href="/services/graphics"
													class="d-flex justify-content-start align-items-center"
												>
													<span
														class="text textcolor1 semibold text-capitalize"
													>
														Explore graphics services
													</span>
													<i class="fa fa-chevron-right" aria-hidden="true"></i>
													<span class="borderspan ms-2"> </span>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- our clients-->
<section class="featuredvideo m80">
	<div class="container">
		<div
			class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			data-aos="fade-up"
			data-aos-duration="2000"
			data-aos-delay="100"
		>
			<div class="blocklist section1">
				<h3 class="fontsize12 semibold mb-4 semibold text-uppercase textcolor1">
					Our clients include...
				</h3>
				<div class="row">
					<ng-container>
						<div class="col-md-12">
							<div class="row">
								<div
									class="col custom-col mb-lg-5 mb-md-4 mb-4"
									*ngFor="let image of filteredClients; let i = index"
								>
									<a href="/">
										<img
											src="{{ image.img }}"
											alt="{{ image.alt }}"
											class="img-fluid"
											data-aos="zoom-in"
											data-aos-duration="1500"
											data-aos-delay="50"
											width="210"
											decoding="async"
											height="57"
											loading="lazy"
										/>
									</a>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- our clients-->
<!-- Service sections-->
<section class="philosophy position-relative">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="content">
					<h3
						class="fontsize12 semibold linenormal text-uppercase"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Our Philosophy
					</h3>
					<h2
						class="size90 mb-md-3 mb-sm-3 mb-2"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<span class="textcolor1 light">Beauty, Balance, </span
						><span class="barcely">And </span>
						<span class="custom-block light"> Custom Craftsmanship </span>
					</h2>
					<div class="row">
						<div
							class="col-xxl-7 col-xl-7 col-lg-8 col-md-8 mb-5"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<p class="size24 textcolor1 lufgaregular">
								At Pixtar, we believe that design isn’t just about
								aesthetics—it’s about creating balance, impact, and
								authenticity. Every project we deliver is built from the ground
								up with no templates—because your business deserves nothing less
								than original.
							</p>
						</div>

						<!-- first block -->
						<div
							class="col-lg-11 offset-lg-1 me-lg-0 col-md-11 col-sm-12 col-12 mx-md-auto"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<div class="imagecent text-end">
								<img
									src="{{ baseUrl }}/img/home/services/homepage-miniaar.webp"
									alt="web designing agency"
									height="490"
									width="833"
									decoding="async"
									loading="lazy"
								/>
								<div class="card cardright">
									<a href="/project-details/miniaar" class="">
										<div class="text">
											<p class="p1 semibold">Miniaar Bridal & Couture</p>
											<p class="lufgalight">Branding & e-Commerce Website</p>
										</div>
										<div class="cstcardright">
											<span class="borderspan"
												><i class="fa fa-chevron-right" aria-hidden="true"></i
											></span>
										</div>
									</a>
								</div>
							</div>
						</div>
						<!-- first block -->
						<!-- second block -->
						<div
							class="col-lg-11 ms-lg-0 col-md-11 col-sm-12 col-12 mx-md-auto"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<div class="imagecent">
								<img
									src="{{ baseUrl }}/img/home/services/homepage-dnour.webp"
									alt="Branding agency in Dubai "
									width="833"
									height="490"
									loading="lazy"
									decoding="async"
								/>

								<div class="card cardleft">
									<a href="/project-details/dnour" class="">
										<div class="text">
											<p class="p1 semibold">D’NOUR Dubai</p>
											<p class="lufgalight">Branding & eCommerce Website</p>
										</div>
										<div class="cstcardleft">
											<span class="borderspan"
												><i class="fa fa-chevron-right" aria-hidden="true"></i
											></span>
										</div>
									</a>
								</div>
							</div>
						</div>
						<!-- second block -->
						<!-- third block -->
						<div
							class="col-lg-11 offset-lg-1 me-lg-0 col-md-11 col-sm-12 col-12 mx-md-auto"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<div class="imagecent text-end">
								<img
									src="{{
										baseUrl
									}}/img/home/services/homepage-detail-master.webp"
									alt="rebranding agency dubai"
									width="833"
									height="490"
									loading="lazy"
									decoding="async"
								/>
								<div class="card cardright">
									<a href="/project-details/detail-master" class="">
										<div class="text">
											<p class="p1 semibold">Detail Master</p>
											<p class="lufgalight">Branding & Website</p>
										</div>
										<div class="cstcardright">
											<span class="borderspan"
												><i class="fa fa-chevron-right" aria-hidden="true"></i
											></span>
										</div>
									</a>
								</div>
							</div>
						</div>
						<!-- third block -->
						<!-- fourth block -->
						<div
							class="col-lg-11 ms-lg-0 col-md-11 col-sm-12 col-12 mx-md-auto"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<div class="imagecent mb-5">
								<img
									src="{{
										baseUrl
									}}/img/home/services/homepage-spacexfitness.webp"
									alt="best web design company in dubai"
									width="833"
									height="490"
									loading="lazy"
									decoding="async"
								/>
								<div class="card cardleft">
									<a href="/project-details/spacex" class="">
										<div class="text">
											<p class="p1 semibold">Space X Fitness</p>
											<p class="lufgalight">Branding & Website</p>
										</div>
										<div class="cstcardleft">
											<span class="borderspan"
												><i class="fa fa-chevron-right" aria-hidden="true"></i
											></span>
										</div>
									</a>
								</div>
							</div>
						</div>
						<!-- fourth block -->
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="mbrem5 position-relative">
			<div class="position-absolute start-50 translate-middle mbrem8">
				<p>
					<a href="/projects" class="cstbtn cstbtn128">
						<span class="text text128 semibold text-capitalize">
							Explore All Work</span>
						<i class="fa fa-chevron-right" aria-hidden="true"></i>
						<span class="borderspan">
						</span>
					</a>
				</p>
			</div>
		</div> -->
		<div class="position-relative mtrem5">
			<div class="position-absolute translate-middle up-arrow">
				<div class="linkToPackages">
					<a
						href="projects"
						class="d-flex justify-content-start align-items-center"
					>
						<span class="text textcolor1 semibold text-capitalize"
							>Explore All Work</span
						>
						<i class="fa fa-chevron-right" aria-hidden="true"></i>
						<span class="borderspan"> </span>
					</a>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="success-story">
	<div class="mask">
		<img
			src="{{ baseUrl }}/img/home/pixtar-mask.webp"
			alt="web designing agency dubai"
			width="645"
			height="956"
			loading="lazy"
			decoding="async"
		/>
	</div>
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="content">
					<h3 class="fontsize12 text-uppercase textcolor1 semibold">
						Client Success Stories
					</h3>
					<h2 class="size90 textcolor1 light">
						And our <span class="barcely">Creativity </span>
						<span class="d-block textcolor2 light">
							Inspired by your story
						</span>
					</h2>
				</div>
			</div>
		</div>
	</div>
</section>
<app-testimonial></app-testimonial>
<!-- Successful story sections-->

<!-- dark creativit section -->
<section class="bannerdrk creativity">
	<div class="container">
		<div class="row">
			<div
				class="col-md-10 m-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="row">
					<div
						class="col-md-6 col-sm-6"
						data-aos="fade-up"
						data-aos-duration="1000"
						data-aos-delay="100"
					>
						<div class="creative">
							<h3 class="fontsize12 semibold text-white text-uppercase">
								Our promise
							</h3>
							<h2 class="d-md-block d-lg-block d-xl-block d-xxl-block size90">
								<span class="textcolor6 light"> We Go</span>
								<span class="barcely"> Beyond </span>
							</h2>
							<h2 class="d-block size90 light">The Limits<br />For You</h2>
						</div>
					</div>
					<div
						class="col-md-6 col-sm-6"
						data-aos="fade-up"
						data-aos-duration="1000"
						data-aos-delay="100"
					>
						<div class="d-flex justify-content-center align-items-center h-100">
							<p class="mb-0">
								Design is only part of what we do. We partner with you to solve
								problems, meet challenges, and grow together—always with 100%
								transparency and trust.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- dark creativit section -->

<!-- Faq section Starts -->
<!-- <section class="section bannerdrk faqsection">
	<div class="container">
		<div class="row">
			<div class="col-md-10 col-sm-11 col-11 m-auto">
				<div class="row">
					<div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
						<div class="creative">
							<h1 class="">
								What <br /> makes Pixtar <br /> Special? <br /> <span> And other FAQs… </span>
							</h1>
						</div>
					</div>
					<div class="col-lg-7 offset-lg-1 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1000"
						data-aos-delay="100">
						<div class="d-block ">
							<div class="custom-collapse footer-collapse">
								<div class="accordion" id="accordionExample1">
									<div class="accordion-item ">
										<h2 class="accordion-header" id="headingOne">
											<button class="accordion-button collapsed brdtp" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
												Alright, no secrets – what makes Pixtar stand out?
											</button>
										</h2>
										<div id="collapseOne" class="accordion-collapse collapse fadeInLeft" aria-labelledby="headingOne"
											data-bs-parent="#accordionExample1">

											<div class="accordion-body">
												Pixtar stands out for our unique blend of creativity, strategy, and a deep commitment to client
												satisfaction. We don’t just design; we craft memorable, user-friendly experiences that make
												brands shine.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h2 class="accordion-header" id="headingThree">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
												Where are you based?
											</button>
										</h2>
										<div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												Virtually, next door! We’re proudly based in Dubai, UAE, but our team collaborates with clients
												worldwide, making distance no barrier to outstanding design!

												Our business hours are 9 am–6 pm GST / 1 am–10 am EST / 10 pm–7 am PST. But with our
												early-rising CEO and night-owl CTO, we’re always able to sync up with clients from LA all the
												way to Australia—and all the lovely places in between.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h2 class="accordion-header" id="headingFour">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
												How are you different from a freelance designer?
											</button>
										</h2>
										<div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												At Pixtar, you get the expertise of an entire team, not just one individual. We bring together
												specialized skills in design, strategy, and development, providing a more comprehensive approach
												and smoother project delivery.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h2 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
												What other design magic do you offer?
											</button>
										</h2>
										<div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												Besides website design, we specialize in branding, UI/UX design, graphic design, and digital
												marketing assets. Whatever your design needs, Pixtar has the creative solution.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h2 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
												Who do you usually work with?
											</button>
										</h2>
										<div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												We collaborate with businesses of all sizes—from startups to established brands—across a range
												of industries, including Lifestyle, healthcare, technology, real estate, and more.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
												Which platforms do you use for building websites?
											</button>
										</h2>
										<div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												We work with popular platforms like Angular, Node.js, React, Shopify, Magento and Webflow,
												ensuring you get a website that’s not only beautiful but also easy to manage and scalable.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed brdbtm" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
												I’m in! When can we get started?
											</button>
										</h2>
										<div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												We’re thrilled to have you onboard! Just reach out through our contact page, and we’ll set up a
												kickoff meeting to dive into your project.
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section> -->
<app-faq-component></app-faq-component>
<!-- Faq section ends -->

<div id="googleReviews" style="display: none"></div>
<section id="reviews" style="display: none">
	<div id="title"></div>
	<div id="reviews"></div>
</section>

<!-- Media Carosual Popup -->
<!-- <ng-template #videomodal let-modal style="z-index: 0;">
	<button type="button" class="btn" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')"><span
			class="fa fa-times" aria-hidden="true"></span></button>
	<video class=" h-auto desktopimg" id="myVideo3" style="width: 100%; height:100%;" autoplay="true" loop="true"
		oncanplay="this.play()" controls>
		<source src="{{baseUrl}}/pixtar logo animation 6.MP4" type="video/mp4">
		<source src="{{baseUrl}}/pixtar logo animation 6.MP4" type="video/ogg">
		Your browser does not support HTML5 video.
	</video>
</ng-template> -->
